import { TakeoffsSidePanelProvider } from "src/routes/libraries/plan-package-v2/components/takeoffs/side-panel/TakeoffsSidePanelProvider";
import { TakeoffsTabHeader } from "src/routes/libraries/plan-package-v2/components/takeoffs/TakeoffsTabHeader";
import { TakeoffsTable } from "src/routes/libraries/plan-package-v2/components/takeoffs/TakeoffsTable";
import type { PlanPackageTabProps } from "src/routes/libraries/plan-package-v2/PlanPackagePageV2";
import { TakeoffsManagerProvider } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";

export function TakeoffsTab(props: PlanPackageTabProps) {
  const { planPackageId, versionId } = props;
  return (
    <TakeoffsManagerProvider planPackageId={planPackageId} versionId={versionId} syncViewToUrl={false}>
      <TakeoffsSidePanelProvider>
        <TakeoffsTabHeader />
        <TakeoffsTable />
      </TakeoffsSidePanelProvider>
    </TakeoffsManagerProvider>
  );
}
